// ABOUTME: A segment's scheduling embed: the Nylas slot picker for a one-on-one coaching segment
// ABOUTME: whose coach books through Nylas; everything else, including LPF, keeps FreeBusy
import { observer } from 'mobx-react';
import * as React from 'react';
import Freebusy from '.';
import { findLink } from '../../LinkyLinky';
import SegmentCoachingScheduler from './SegmentCoachingScheduler';

type Props = React.ComponentProps<typeof Freebusy>;

// The server links the scheduler only on a one-on-one coaching segment; the kind check keeps
// any other embed on FreeBusy regardless.
const FreebusyEmbed: React.FC<Props> = (props) =>
  props.links
    .andThen(findLink('coaching-scheduler'))
    .filter(() => props.node.kind === 'freebusy-coaching')
    .map((schedulerLink) => (
      <SegmentCoachingScheduler
        key={schedulerLink.href}
        schedulerLink={schedulerLink}
        participantEmail={props.node.proposerParticipant.email}
        segmentStore={props.segmentStore}
      />
    ))
    .getOrElse(() => <Freebusy {...props} />);

export default observer(FreebusyEmbed);
